<template>
  <va-create-layout>
    <livestock-farms-form :title="title" :item="item"></livestock-farms-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
